__turbopack_context__.v({
  "gradient": "Gradient-module__FSHokW__gradient",
  "gradientLeft": "Gradient-module__FSHokW__gradientLeft",
});
